import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/validation';

export const SignUpFormSchema = z
  .object({
    email: z
      .string({
        required_error: VALIDATION_MESSAGES.EMAIL_REQUIRED,
      })
      .email({
        message: VALIDATION_MESSAGES.EMAIL_INVALID,
      }),
    password: z
      .string({
        required_error: VALIDATION_MESSAGES.PASSWORD_REQUIRED,
      })
      .min(8, {
        message: VALIDATION_MESSAGES.PASSWORD_TOO_SHORT,
      })
      .regex(/[A-Z]/, {
        message: VALIDATION_MESSAGES.PASSWORD_UPPERCASE_REQUIRED,
      })
      .regex(/[a-z]/, {
        message: VALIDATION_MESSAGES.PASSWORD_LOWERCASE_REQUIRED,
      })
      .regex(/[0-9]/, {
        message: VALIDATION_MESSAGES.PASSWORD_NUMBER_REQUIRED,
      })
      .regex(/[^A-Za-z0-9]/, {
        message: VALIDATION_MESSAGES.PASSWORD_SPECIAL_CHAR_REQUIRED,
      }),
    confirmPassword: z.string({
      required_error: VALIDATION_MESSAGES.CONFIRM_PASSWORD_REQUIRED_SIGNUP,
    }),
    terms: z.boolean().refine((v) => v, {
      message: VALIDATION_MESSAGES.TERMS_REQUIRED,
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: VALIDATION_MESSAGES.PASSWORDS_MUST_MATCH_SIGNUP,
    path: ['confirmPassword'],
  });
